import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useLang } from "@/context/LanguageContext";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link has been sent.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("reset_password")}>
      {sent ? (
        <div className="rounded-xl border border-emerald-300 bg-emerald-50 p-5 text-sm text-emerald-800" data-testid="forgot-sent">
          Please check your email for a password reset link. It expires in 1 hour.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label htmlFor="email">{t("email")}</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" className="mt-1.5" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#8B1E2B] hover:bg-[#6f1622] text-white" data-testid="forgot-submit-button">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} {t("send_reset")}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
